import { Maybe } from "../models/Maybe";

export class FilterService {
    maybeFilter: Maybe<string | null>;

    constructor(filterValue: string | null = null) {
        this.maybeFilter = Maybe.justIf(this.isValid(filterValue), filterValue);
    }

    get isValueEmpty(): boolean {
        return this.maybeFilter.value === "";
    }

    applyFilter<T>(list: readonly T[], getSearchKey: (value: T) => string): readonly T[] {
        return this.maybeFilter.ifElse(
            (value) =>
                list.filter((listItem) =>
                    getSearchKey(listItem)
                        .toLowerCase()
                        .includes((value ?? "").toLowerCase()),
                ),
            () => list,
        );
    }

    private isValid(filterValue: string | null) {
        return filterValue !== null;
    }
}
